import { FC } from "react"
import styles from "./QuestTab.module.scss"
import { QuestsHero, QuestsList } from "./ui"

export const QuestTab: FC = () => {
  return (
    <div className={styles.QuestTab}>
      <QuestsHero />
      <QuestsList />
    </div>
  )
}
